@if (isLoading) {
	<div class="pp-path-state">{{ 'mes.production-plan.path.loading' | translate }}</div>
} @else if (loadError && paths.length === 0) {
	<div class="pp-path-state">{{ 'mes.production-plan.path.error' | translate }}</div>
} @else if (paths.length === 0) {
	<div class="pp-path-state">{{ 'mes.production-plan.path.empty' | translate }}</div>
} @else {
	<div class="pp-toolbar">
		<mat-slide-toggle [checked]="showFull" (change)="onFullToggle($event.checked)">
			{{ 'mes.production-plan.path.full' | translate }}
		</mat-slide-toggle>
		<button type="button" mat-icon-button [attr.aria-label]="(isFullscreen ? 'mes.production-plan.path.exit-fullscreen' : 'mes.production-plan.path.fullscreen') | translate" (click)="toggleFullscreen()">
			<mat-icon>{{ isFullscreen ? 'fullscreen_exit' : 'fullscreen' }}</mat-icon>
		</button>
	</div>
	<div class="pp-path-list">
		@for (path of paths; track $index) {
			<div class="pp-path" [style.width.px]="path.width" [style.height.px]="path.height">
				<svg class="pp-edges" [attr.width]="path.width" [attr.height]="path.height">
					@for (edge of path.edges; track $index) {
						<path class="pp-edge" [attr.d]="edge"></path>
					}
				</svg>
				@for (node of path.nodes; track node.id) {
					<div class="pp-node" [class.pp-node--passthrough]="node.passthrough" [style.left.px]="node.x" [style.top.px]="node.y" [style.width.px]="nodeWidth" [style.height.px]="nodeHeight" [style.background-color]="node.background" [style.border-left]="node.accent ? '4px solid ' + node.accent : null">
						@if (node.passthrough) {
							<span class="pp-node-terminal" [title]="node.terminalName">
								{{ node.terminalName }}
							</span>
						} @else {
							<span class="pp-node-head">
								<span class="pp-node-alias" [title]="node.alias">
									{{ node.alias }}
								</span>
								<span class="pp-node-layer">
									{{ 'mes.production-plan.path.layer' | translate }}
									{{ node.layer }}
								</span>
							</span>
							<span class="pp-node-terminal" [title]="node.terminalName">
								{{ node.terminalName }}
							</span>
						}
					</div>
				}
			</div>
		}
	</div>
}
